import { useParams } from 'react-router';
import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../adminlogin/useAuthContext';
import API_URL from '../../api/APIUrl'

const ViewDocuments = () => {

    const {adminuser} = useAuthContext();

    const {id} = useParams(); 

    const [student_id, setStudentId] = useState('');
    const [father_aadhar_file, setFatherAadharFile] = useState('');
    const [mother_aadhar_file, setMotherAadharFile] = useState('');
    const [student_aadhar_file, setStudentAadharFile] = useState('');
    const [student_income_file, setStudentIncomeFile] = useState('');

    const [father_aadhar_file_link, setFatherAadharFileLink] = useState('');
    const [mother_aadhar_file_link, setMotherAadharFileLink] = useState('');
    const [student_aadhar_file_link, setStudentAadharFileLink] = useState('');
    const [student_income_file_link, setStudentIncomeFileLink] = useState('');

    const [sub_caste, setSubCaste] = useState('');

    const [father_its_file, setFatherITSFile] = useState('');
    const [mother_its_file, setMotherITSFile] = useState('');
    const [student_its_file, setStudentITSFile] = useState('');

    const [father_its_file_link, setFatherITSFileLink] = useState('');
    const [mother_its_file_link, setMotherITSFileLink] = useState('');
    const [student_its_file_link, setStudentITSFileLink] = useState('');

    const [emptyFields, setEmptyFields] = useState([]);
    const [error,setError] = useState(null);
    const [msg,setMsg] = useState(null);
    const [isSaved, setIsSaved] = useState(false);

    var json;

    useEffect(() =>{
        const fetchStudentDocumentData = async () =>{
            try {
                console.log(API_URL.GET_ADMIN_STUDENT_DOCUMENT + "/" + id)
                const response = await fetch(API_URL.GET_ADMIN_STUDENT_DOCUMENT + "/" + id,{
                    method: 'GET', 
                    headers:{
                        'Content-Type' : 'application/json',
                        'Authorization': `Bearer ${adminuser.token}` 
                    },
                });
                json = await response.json();
                console.log(json);
                if(!response.ok){
                    setMsg('');
                    setError(json.error);        
                }
                if(response.ok){
                  //  setStudentId(json.student_id);
                    if(json.father_aadhar_file){
                        setFatherAadharFileLink(API_URL.DOCUMENT_URL+ json.father_aadhar_file);
                    }
                    if(json.mother_aadhar_file){
                        setMotherAadharFileLink(API_URL.DOCUMENT_URL+ json.mother_aadhar_file);
                    }
                    if(json.student_aadhar_file){
                        setStudentAadharFileLink(API_URL.DOCUMENT_URL+ json.student_aadhar_file);
                    }
                    if(json.student_income_file){
                        setStudentIncomeFileLink(API_URL.DOCUMENT_URL+ json.student_income_file);
                    }
                    

                    //if(sub_caste==="bohra"){
                        if( json.father_its_file){
                            setFatherITSFileLink(API_URL.DOCUMENT_URL+ json.father_its_file);
                        }
                        if(json.mother_its_file){
                            setMotherITSFileLink(API_URL.DOCUMENT_URL+ json.mother_its_file);
                        }
                        if(json.student_its_file){
                            setStudentITSFileLink(API_URL.DOCUMENT_URL+ json.student_its_file);
                        }
                        
                  //  }

                    setError(null);
                    setMsg(json.message);
                    console.log("Student Document Data Fetched By Id: ",student_id);
                }
    
               // console.log("FetchOutput " + json.error);
            } catch (error) {
                setError(error.message);
            }
        }
        fetchStudentDocumentData();
      },[id]);

 
    return (
        <form style={styles.form}>
        <h2 style={styles.title}>Student Documents</h2>
        {error && <div className="error-message">{error}</div>}
        {msg && <div className="success-message">{msg}</div>}
  
       
  
        <div style={styles.fieldRow}>
           
          <div style={styles.fieldContainer}>
          
              {father_aadhar_file_link && ( 
                    <>
                         <label style={styles.label}>Fathers Aadhar</label>
                         <a target="_blank" href={father_aadhar_file_link}>View File</a>
                    </>
               )
              }

          </div>

       
          <div style={styles.fieldContainer}>
           
              {mother_aadhar_file_link && ( 
                    <>
                         <label style={styles.label}>Mothers Aadhar</label>
                         <a target="_blank" href={mother_aadhar_file_link}>View File</a>
                    </>
               )
              }
          </div>

          <div style={styles.fieldContainer}>
          
              {student_aadhar_file_link && ( 
                    <>
                         <label style={styles.label}>Student Aadhar</label>
                         <a target="_blank" href={student_aadhar_file_link}>View File</a>
                    </>
               )
              }
          </div>

          <div style={styles.fieldContainer}>
          
          {student_income_file_link && ( 
                <>
                     <label style={styles.label}>Student Income Certificate</label>
                     <a target="_blank" href={student_income_file_link}>View File</a>
                </>
           )
          }
      </div>

        </div>

     
              <>
              {father_its_file_link && (  <h2 style={styles.title}>Bohra ITS Documents</h2>)}
              
                 <div style={styles.fieldRow}>
                     <div style={styles.fieldContainer}>
                       
                        {father_its_file_link && ( 
                                <>
                                    <label style={styles.label}>Fathers ITS</label>
                                    <a target="_blank" href={father_its_file_link}>View File</a>
                                </>
                        )
                        }

                    </div>


                    <div style={styles.fieldContainer}>
                       
                        {mother_its_file_link && ( 
                                <>
                                    <label style={styles.label}>Mothers ITS</label>
                                    <a target="_blank" href={mother_its_file_link}>View File</a>
                                </>
                        )
                        }

                    </div>


                    <div style={styles.fieldContainer}>
                       
                        {student_its_file_link && ( 
                                <>
                                    <label style={styles.label}>Student ITS</label>
                                    <a target="_blank" href={student_its_file_link}>View File</a>
                                </>
                        )
                        }

                    </div>
                 </div>
              </>  
      
      </form>
    )
}

const styles = {
    form: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '30px',
        backgroundColor: '#f3f4f6',
        borderRadius: '8px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Arial, sans-serif',
    },
    title: {
        textAlign: 'center',
        fontSize: '1.5rem',
        color: '#333',
        marginBottom: '20px',
    },
    fieldRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        justifyContent: 'space-between',
        marginBottom: '15px',
    },
    fieldContainer: {
        flex: '1 1 calc(50% - 10px)',
        marginBottom: '15px',
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        fontWeight: 'bold',
        fontSize: '0.9rem',
        color: '#555',
        marginBottom: '8px',
    },
    input: {
        padding: '10px 12px',
        borderRadius: '6px',
        border: '1px solid #d1d5db',
        backgroundColor: '#f9fafb',
        fontSize: '0.95rem',
        color: '#333',
        transition: 'border-color 0.3s ease',
    },
    inputFocus: {
        borderColor: '#E60240', // Accent color on focus
        outline: 'none',
    },
    link: {
        fontSize: '0.9rem',
        color: '#007bff',
        textDecoration: 'underline',
        cursor: 'pointer',
        marginTop: '5px',
        alignSelf: 'flex-start',
    },
    button: {
        width: '100%',
        backgroundColor: '#E60240',
        color: '#FFFFFF',
        padding: '12px 0',
        fontSize: '1rem',
        fontWeight: '600',
        borderRadius: '6px',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, transform 0.3s ease',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
    },
    hover: {
        backgroundColor: '#c20035',
        transform: 'translateY(-2px)',
        boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.2)',
    },
};


export default ViewDocuments;